import { can, type Permission } from '@brandschutz/shared';
import { useAuth } from './auth-context';

/**
 * Hook für Permission-Checks im UI.
 * Returns false wenn nicht eingeloggt.
 */
export function useCanI(permission: Permission): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return can(user.role, permission);
}

/**
 * Mehrere Permissions auf einmal — alle müssen erfüllt sein.
 */
export function useCanIAll(...permissions: Permission[]): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return permissions.every((p) => can(user.role, p));
}

/**
 * Mehrere Permissions auf einmal — mindestens eine muss erfüllt sein.
 */
export function useCanIAny(...permissions: Permission[]): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return permissions.some((p) => can(user.role, p));
}
